import { api } from '@/lib/api'

/** @typedef {import('@/types/api').ChairBoardPayload} ChairBoardPayload */

/**
 * @returns {Promise<ChairBoardPayload>}
 */
export async function fetchChairBoard() {
  const { data } = await api.get('/chair-board')
  return data.data
}

/**
 * @param {Record<string, unknown>} payload
 * @returns {Promise<ChairBoardPayload>}
 */
export async function assignChairSession(payload) {
  const { data } = await api.post('/chair-board/sessions', payload)
  return data.data.board
}

/**
 * @param {number} sessionId
 * @returns {Promise<ChairBoardPayload>}
 */
export async function startChairSession(sessionId) {
  const { data } = await api.post(`/chair-board/sessions/${sessionId}/start`)
  return data.data.board
}

/**
 * @param {number} sessionId
 * @param {{ start_turnover?: boolean }} [options]
 * @returns {Promise<ChairBoardPayload>}
 */
export async function completeChairSession(sessionId, options = {}) {
  const { data } = await api.post(`/chair-board/sessions/${sessionId}/complete`, options)
  return data.data.board
}

/**
 * @param {number} sessionId
 * @returns {Promise<ChairBoardPayload>}
 */
export async function finishChairTurnover(sessionId) {
  const { data } = await api.post(`/chair-board/sessions/${sessionId}/finish-turnover`)
  return data.data.board
}
